import React, { useEffect, useState } from 'react';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import TableComponent from '../../../components/DataTable/TableComponent';
import Pagination from '../../../components/Pagination/Pagination';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { dateIntoYYYY_MM_DD } from '../../../utils/dateTimeConverter';
import { statusCodeToStatusDetails } from '../../../utils/dataInterChange';

const GoogleAdsTab = ({ date, selectedAdSet, selectedGoogleAccount }) => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    async function getList() {
        loadingShow();
        let postData = {
            googleAdsClientId: selectedGoogleAccount?.googleAdsClientId
        }
        if (date?.startDate) {
            postData.startDate = dateIntoYYYY_MM_DD(date.startDate);
            postData.endDate = dateIntoYYYY_MM_DD(date.endDate);
        }
        let url = `${urlApi.getGoogleAdsList}?page=${activePage}&limit=${perPage}`;
        if (selectedAdSet) {
            url += `&adGroupId=${selectedAdSet?._id}`;
        }
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        getList();
    }, [activePage, date, selectedAdSet, selectedGoogleAccount]);

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Ads ID", center: "true", selector: (row) => row?.adId, grow: 1.4, cell: (row) => (
                <p className="mb-0">{row?.adId}</p>
            )
        }, {
            name: "Ads Account", center: "true", omit: true, selector: (row) => row?.category, grow: 1.4, cell: (row) => (
                <p className="mb-0">{row?.account_name ?? "--"}</p>
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.amount, cell: (row) => (
                <p className={`py-1 mb-0 px-3 rounded-full font-medium text-[10px]`}
                    style={{ backgroundColor: statusCodeToStatusDetails(row?.adStatus)?.accentColor, color: statusCodeToStatusDetails(row?.adStatus)?.color }}
                >{statusCodeToStatusDetails(row?.adStatus)?.name}</p>
            )
        }, {
            name: "Amount", center: "true", selector: (row) => row?.spend, grow: 1.4, cell: (row) => (
                "₹" + row?.spend?.toFixed(2) ?? "0"
            )
        }, {
            name: "Conversions", center: "true", selector: (row) => row?.amount, grow: 1.4, cell: (row) => (
                row?.conversions || "--"
            )
        }, {
            name: "Cost/Conversions", center: "true", selector: (row) => row?.amount, grow: 1.4, cell: (row) => (
                row?.cost_per_conversion?.toFixed(2) || "--"
            )
        }, {
            name: "Interactions", center: "true", selector: (row) => row?.interactions, grow: 1.4, cell: (row) => (
                row?.interactions ?? "--"
            )
        }, {
            name: "Interaction Rate", center: "true", selector: (row) => row?.interaction_rate, grow: 1.4, cell: (row) => (
                row?.interaction_rate?.toFixed(2) ?? "--"
            )
        }, {
            name: "Impression", center: "true", selector: (row) => row?.impressions, grow: 1.4, cell: (row) => (
                row?.impressions ?? "--"
            )
        }, {
            name: "Clicks", center: "true", selector: (row) => row?.clicks, grow: 1.4, cell: (row) => (
                row?.clicks
            )
        }, {
            name: "CTR", center: "true", selector: (row) => row?.ctr, grow: 1.4, cell: (row) => (
                row?.ctr?.toFixed(2)
            )
        }
    ];
    return (
        <>
            <TableComponent
                columns={columns}
                data={tableData.data}
                isHeader={true}
                totalRows={tableData.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </>
    )
}

export default GoogleAdsTab